// src/components/admin/AdminSidebar.jsx
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  FaTachometerAlt,
  FaBoxes,
  FaPlus,
  FaCog,
  FaSignOutAlt,
  FaShoppingCart,
  FaChevronDown,
  FaChevronUp,
  FaPalette,
  FaImage,
  FaTags,
  FaSlidersH,
  FaTshirt,
  FaInfoCircle,
  FaEnvelope,
  FaAddressCard,
  FaFileAlt,
  FaCreditCard,
  FaUsers,
  FaHeadset,
  FaBars,
  FaStore
} from 'react-icons/fa';
import './AdminSidebar.css';

const AdminSidebar = () => {
  const [storeLogo, setStoreLogo] = useState('');
  const [storeName, setStoreName] = useState('UrbanThread');
  const [logoError, setLogoError] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const menuItems = [
    { path: '/admin/dashboard', icon: <FaTachometerAlt />, label: 'Dashboard' },
    { path: '/admin/orders', icon: <FaShoppingCart />, label: 'Orders' },    
    { path: '/admin/customers', icon: <FaUsers />, label: 'Customers' },
    /*
    { path: '/admin/add-product', icon: <FaPlus />, label: 'Add Product' },
     */
  ];

  const settingsItems = [
    /*
    { path: '/admin/settings/colors', icon: <FaPalette />, label: 'Colors' },    
    { path: '/admin/settings/category-management', icon: <FaTags />, label: 'Category Management' },
    { path: '/admin/settings/category-slider', icon: <FaSlidersH />, label: 'Category Slider' },
    */
    { path: '/admin/settings/navbar', icon: <FaBars />, label: 'Navbar' },
    { path: '/admin/settings/hero-slider', icon: <FaImage />, label: 'Hero Slider' },
    { path: '/admin/settings/everyday-wardrobe', icon: <FaTshirt />, label: 'Everyday Wardrobe' },
    /*
    { path: '/admin/settings/about-page', icon: <FaInfoCircle />, label: 'About Page' },
    { path: '/admin/settings/contact-page', icon: <FaEnvelope />, label: 'Contact Page' },
     */
    { path: '/admin/settings/categories', icon: <FaTags />, label: 'Categories' },
    { path: '/admin/settings/contact-info', icon: <FaAddressCard />, label: 'Footer Info' },
    /*
    { path: '/admin/settings/footer', icon: <FaFileAlt />, label: 'Footer' },
     
    { path: '/admin/settings/payments', icon: <FaCreditCard />, label: 'Payments' },
     */
  ];

  useEffect(() => {
    const loadBranding = async () => {
      try {
        const response = await fetch('https://demo-site.storii.com.pk/demo-api/public/get-settings.php');
        const data = await response.json();
        if (data.success && data.settings) {
          setStoreLogo(data.settings.logo || '');
          setStoreName(data.settings.store_name || 'UrbanThread');
        }
      } catch (error) {
        console.error('Error loading branding:', error);
      }
    };
    loadBranding();
  }, []);

  const handleLogout = async () => {
    try {
      await fetch('https://demo-site.storii.com.pk/demo-api/admin/logout.php', {
        method: 'POST'
      });
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminData');
      navigate('/admin/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const toggleSettings = () => {
    setIsSettingsOpen(!isSettingsOpen);
  };

  const isSettingsActive = location.pathname.includes('/admin/settings');

  return (
    <div className="admin-sidebar">
      <div className="sidebar-header">
        {storeLogo && !logoError ? (
          <img
            src={`${storeLogo}?v=${Date.now()}`}
            alt={storeName}
            className="sidebar-logo-img"
            onError={() => setLogoError(true)}
          />
        ) : (
          <div className="sidebar-avatar">{storeName.charAt(0).toUpperCase()}</div>
        )}
        <div className="sidebar-header-text">
          <h3>{storeName}</h3>
          <span>Storefront</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        <div className="sidebar-section-label">Main</div>

        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`sidebar-link ${location.pathname === item.path ? 'active' : ''}`}
            title={item.label}
          >
            {item.icon}
            <span>{item.label}</span>
          </Link>
        ))}

        <div className="sidebar-section-label">Store</div>

        {/* TODO: confirm this path matches what's registered in App.js —
            App.js was originally given the route as /admin/storefront
            (no hyphen). If that's what's actually live, change this to
            "/admin/storefront" or the link will 404. */}
        <Link
          to="/admin/store-front"
          className={`sidebar-link ${location.pathname === '/admin/store-front' ? 'active' : ''}`}
        >
          <FaStore />
          <span>Storefront</span>
        </Link>

        <Link
          to="/admin/products"
          className={`sidebar-link ${location.pathname === '/admin/products' ? 'active' : ''}`}
        >          
          <FaBoxes />
          <span>Product</span>
        </Link>

        <Link
          to="/admin/settings-store"
          className={`sidebar-link ${location.pathname === '/admin/settings-store' ? 'active' : ''}`}
        >
          <FaPalette />
          <span>StoreSettings</span>
        </Link>

        {/* 
        <Link
          to="/admin/payments"
          className={`sidebar-link ${location.pathname === '/admin/payments' ? 'active' : ''}`}
        >
          <FaStore />
          <span>Payments</span>
        </Link>
        */}

        {/* Settings Dropdown - Simplified */}
        {/*        
        <div className="settings-wrapper">
          <div
            className={`settings-header ${isSettingsActive ? 'active' : ''}`}
            onClick={toggleSettings}
          >
            <FaCog />
            <span>Settings</span>
            {isSettingsOpen ? <FaChevronUp className="arrow-icon" /> : <FaChevronDown className="arrow-icon" />}
          </div>

          {isSettingsOpen && (
            <div className="settings-items">
              {settingsItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`settings-item ${location.pathname === item.path ? 'active' : ''}`}
                  onClick={() => setIsSettingsOpen(false)}
                >
                  {item.icon}
                  <span>{item.label}</span>
                </Link>
              ))}
            </div>
          )}
        </div>
        */}

        <div className="sidebar-section-label">Support </div>

        <Link
          /*
          to="/admin/support"
          */
          className={`sidebar-link ${location.pathname === '/admin/support' ? 'active' : ''}`}
          
        >
          <FaHeadset />
          <span>Support - Coming Soon</span>
        </Link>

        <button onClick={handleLogout} className="logout-btn">
          <FaSignOutAlt />
          <span>Logout</span>
        </button>
      </nav>
    </div>
  );
};

export default AdminSidebar;